const ClientType = Object.freeze({
  LEGAL: 'LEGAL',
  INDIVIDUAL: 'INDIVIDUAL',
});
  
export default ClientType;